import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

import { Query as RootQuery } from 'graphql/models/generated';

export const JSON_EXPORT_QUERY = gql`
  query jsonExport($documentVersion: DocumentVersionInput!, $type: FileExportType!) {
    jsonExport(documentVersion: $documentVersion, type: $type) {
      url
      message
      status
      type
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class JsonExportQuery extends Query<RootQuery> {
  document = JSON_EXPORT_QUERY;
}
